import Fade from "@mui/material/Fade";
import { Stack } from "@mui/material";
import { Header } from "../SignUp/partials/Header";
import { Footer } from "../SignUp/partials/Footer";
import { Container } from "../SignUp/partials/Container";
import { SignInForm } from "./partials/SignInForm";
import { useAppSelector } from "../../store/hooks";
import { selectExtension } from "../../features/extension/extension.selector";
import { SubmitButton } from "../SignUp/partials/SubmitButton";
import { GoogleAuthButton, TextualDivider } from "../../components";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { selectIsLoggedIn } from "../../features/user/user.selector";

const SignIn = () => {
  const navigate = useNavigate();
  const { isExtension } = useAppSelector(selectExtension);
  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  useEffect(() => {
    if (
      isExtension &&
      isLoggedIn 
    ) {
      navigate("/product-analyzer", { replace: true });
    }
  }, [isExtension, isLoggedIn, navigate]);

  return (
    <Container>
      <Fade in timeout={1000}>
        <Stack width="100%" sx={{ marginY: isExtension ? 10 : 0 }}>
          <Header
            title="Sign In"
            subtitle="Join thousands of Amazon sellers already turning data into profits with our platform"
            disableCompanyIdentity
          />
          {/* {!isExtension && <GoogleAuthButton />}
          {!isExtension && (
            <TextualDivider>Or, Sign in with your email</TextualDivider>
          )} */}

          {!isExtension && <SignInForm />}
          {isExtension && (
            <SubmitButton
              type="button"
              onClick={() =>
                window.open(
                  `${process.env.REACT_APP_SERVER_URL}/login?from=extension`,
                  "_blank",
                  "noopener,noreferrer",
                )
              }
              sx={{ marginTop: 10 }}
            >
              Sign In
            </SubmitButton>
          )}

          <Footer
            text="Don’t have an account?"
            linkText="Sign Up"
            link="/signup"
          />
        </Stack>
      </Fade>
    </Container>
  );
};

export default SignIn;
